import Box from '@mui/material/Box'

import { ChipType, EmissionFactorChip } from '@/components/MovingChipAnimation/EmissionFactorChip'

export const chipAnimations = {
    containerShip: {
        id: 'row-1',
        duration: '30s',
        top: 100,
        delay: '1s',
    },
    truck: {
        id: 'row-1',
        duration: '34s',
        top: 100,
        delay: '16s',
    },
    barge: {
        id: 'row-2',
        duration: '30s',
        top: 10,
        delay: '12s',
    },
    wheat: {
        id: 'row-2',
        duration: '33s',
        top: 10,
        delay: '24s',
    },
    oil: {
        id: 'row-2',
        duration: '34s',
        top: 80,
        delay: '15s',
    },
    rice: {
        id: 'row-3',
        duration: '32s',
        top: 8,
        delay: '6s',
    },
    bottle: {
        id: 'row-3',
        duration: '35s',
        top: 24,
        delay: '20s',
    },
    customerGoComet: {
        id: 'row-3',
        duration: '32s',
        top: 8,
        delay: '6s',
    },
    customerChainio: {
        id: 'row-3',
        duration: '35s',
        top: 28,
        delay: '20s',
    },
    customerPaack: {
        id: 'row-2',
        duration: '30s',
        top: 6,
        delay: '12s',
    },
    customerShiptheory: {
        id: 'row-2',
        duration: '33s',
        top: 10,
        delay: '24s',
    },
    customerAgx: {
        id: 'row-1',
        duration: '20s',
        top: 100,
        delay: '2s',
    },
    customerBeacon: {
        id: 'row-1',
        duration: '30s',
        top: 100,
        delay: '1s',
    },
    customerLogixboard: {
        id: 'row-1',
        duration: '34s',
        top: 100,
        delay: '16s',
    },
}

export const AnimatedChip = ({ type }: { type: ChipType }) => {
    const { id, duration, delay, top } = chipAnimations[type]
    return (
        <Box
            sx={{
                position: 'absolute',
                left: '100%',
                top,
                zIndex: 1,
                [`@keyframes ${id}`]: {
                    '0%': {
                        transform: `translate3d(0px, 0, 0)`,
                    },
                    '100%': {
                        // Add 200px to animation width
                        // Chips glide off screen instead of disappear
                        transform: `translate3d(-2320px, 0, 0)`,
                    },
                },
                animation: `${id} ${duration} linear infinite`,
                animationDelay: delay,
                willChange: 'transform',
                backfaceVisibility: 'hidden',
                perspective: 1000,
            }}
        >
            <EmissionFactorChip type={type} />
        </Box>
    )
}
